/** Query param for draft vs generated chip on the video editions tab. */
export const VIDEO_EDITIONS_EDIT_GROUP_QUERY_PARAM = 'editGroup';
